<template>
  <div>
    <div
      style="
        width: 760px;
        margin-bottom: 20px;
        margin-top: 25px;
        position: relative;
      "
      class="lk_content_info_block"
    >
      <div style="display: table-cell; width: 70px">
        <el-icon
          style="
            font-size: 50px;
            position: absolute;
            transform: rotate(180deg);
            left: 20px;
            color: #e82862;
          "
          ><Warning
        /></el-icon>
      </div>
      <div style="display: table-cell">
        <br />
        <span v-if="store.langSelect.value == 0">
          Торговый счет АЕ возможно пополнить криптовалютой USDT блокчейн Tron
          (TRC20), TON или Bitcoin (BTC). Bitcoin принимается только в качестве
          обеспечения. Для пополнения выберите соотв криптовалюту и осуществите
          перевод на адрес кошелька привязанного к вашему торговому счету.
          Зачисление осуществляется автоматически.
        </span>
        <span v-else
          >AE trading account can be funded with USDT blockchain Tron (TRC20), TON or
          Bitcoin (BTC). Bitcoin is only accepted as collateral. To replenish,
          select the appropriate cryptocurrency and transfer to the wallet
          address linked to your trading account. Enrollment is carried out
          automatically.</span>
        <br /><br />
      </div>
    </div>
    <div
      class="table"
      style="height: 300px; width: 700px"
      v-if="store.cryptoServerIsActived.value"
    >
      <div
        class="col"
        style="background-color: #f7f7f7; width: 359px; height: 300px"
      >
        <div style="padding-top: 50px; padding-left: 64px">
          <div style="margin-bottom: 20px">
            <div class="mylabel">
              {{ messages.account[store.langSelect.value] }}:
            </div>
            <div style="margin-top: 6px">
              <div class="myselector" style="width: calc(100% - 64px)">
                <el-select
                  v-model="inAccount"
                  icon-сlass="caret-top"
                  placeholder="Select"
                >
                  <el-option
                    v-for="(item, i) in accounts
                      .filter((v) => {
                        return !v.Account.includes('_');
                      })
                      .sort((a, b) =>
                        a.Account > b.Account
                          ? 1
                          : b.Account > a.Account
                          ? -1
                          : 0
                      )"
                    :key="i"
                    :label="item.Account"
                    :value="item.Account"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div style="margin-bottom: 20px; height: 64px">
            <div style="float: left; width: 100%">
              <div class="mylabel">
                {{ messages.currency[store.langSelect.value] }}:
              </div>
              <div style="margin-top: 6px">
                <div class="myselector" style="width: calc(100% - 64px)">
                  <el-select
                    v-model="inCurrency"
                    icon-сlass="caret-top"
                    placeholder="Select"
                  >
                    <el-option
                      v-for="(item, i) in currency"
                      :key="i"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div style="float: left; margin: 32px 0 0 10px">
              <!--  <span class="all">{{messages.all[store.langSelect.value]}}</span> -->
            </div>
          </div>

          <div>
            <div style="float: left; width: 142px">
              <div class="mylabel">
                {{ messages.thereis[store.langSelect.value] }}:
              </div>
              <div style="margin-top: 6px">
                <div>
                  <div class="mylabel">
                    <span
                      v-if="inInstrument != null"
                      v-text="inInstrument.Shares"
                    ></span>
                    <span v-else>0.00</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col" style="width: 82px; position: relative">
        <div style="position: absolute; left: 27px; top: 115px">
          <svg
            width="30"
            height="20"
            viewBox="0 0 30 2"
            preserveAspectRatio="xMidYMid meet"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1H29"
              stroke="#D4D9DD"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <svg
            width="10"
            height="20"
            viewBox="0 0 10 18"
            style="margin-left: -10px"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1L9 9L1 17"
              stroke="#D4D9DD"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>
      <div
        class="col"
        style="
          background-color: #f7f7f7;
          width: 359px;
          height: 300px;
          position: absolute;
        "
      >
        <div
          style="
            padding-top: 25px;
            margin-left: auto;
            margin-right: auto;
            width: 359px;
          "
          v-if="inCurrency == 'BTC'"
        >
          <div style="width: 175px; margin-left: auto; margin-right: auto">
            <img :src="accountsAddress[inAccount].qrBTC" class="qrImage" />
          </div>
          <div style="width: 100%; text-align: center; font-size: 80%">
            {{ accountsAddress[inAccount].addressBTC }}
            <el-button size="small" @click="doCopy('bit')">
              <el-icon><DocumentCopy /></el-icon>
            </el-button>
          </div>

      <!--    <div
            style="
              margin-top: 15px;
              margin-left: auto;
              margin-right: auto;
              width: 240px;
            "
          >
            <Button
              :text="messages.topupCreateAddrB[store.langSelect.value]"
              acolor="#f7f7f7"
              @click="getNewAddr"
            />
          </div> -->
        </div>
        <div
          style="
            padding-top: 25px;
            margin-left: auto;
            margin-right: auto;
            width: 240px;
          "
          v-if="inCurrency == 'USDT'"
        >
          <div v-if="usdtType == 'TRC20'">
            <div style="width: 175px; margin-left: auto; margin-right: auto">
              <img :src="accountsAddress[inAccount].qrUSDT" class="qrImage" />
            </div>
            <div
              style="
                width: 350px;
                margin: 0 -55px;
                text-align: center;
                font-size: 70%;
              "
            >
              {{ accountsAddress[inAccount].addressUSDT }}
              <el-button size="small" @click="doCopy('usdt')">
                <el-icon><DocumentCopy /></el-icon>
              </el-button>
            </div>
          </div>
          <div v-else>
            <div style="width: 175px; margin-left: auto; margin-right: auto">
              <img :src="accountsAddress[inAccount].qrTonUSDT" class="qrImage" />
            </div>
            <div
              style="
                width: 350px;
                margin: 0 -55px ;
                text-align: center;
                font-size: 70%;
              "
            >
              {{ accountsAddress[inAccount].addressTonUSDT }}
              <el-button size="small" @click="doCopy('usdtton')">
                <el-icon><DocumentCopy /></el-icon>
              </el-button>
            </div>
          </div>
          <div style="margin-top: 5px; text-align: center">
            <el-select
              v-model="usdtType"
              icon-сlass="caret-top"
              placeholder="Select"
            >
              <el-option
                v-for="(item, i) in usdt_type"
                :key="i"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <div
      style="
        width: 90%;
        margin-bottom: 20px;
        margin-top: 25px;
        position: relative;
      "
      class="lk_content_info_block"
      v-else
    >
      <div style="display: table-cell; width: 70px; height: 50px">
        <el-icon
          style="
            font-size: 50px;
            position: absolute;
            transform: rotate(180deg);
            left: 20px;
            color: #e82862;
          "
          ><Warning
        /></el-icon>
      </div>
      <div style="display: table-cell">
        <span v-html="cryptoServerIsNotActive[store.langSelect.value]"></span>
      </div>
      <Button
        text="Refresh"
        @click="CheckCrypto"
        @disabledEvent="disabledRefreshButtonEvent"
        :timer="refreshTimer"
        :disabled="disabledRefreshButton"
        :timerview="true"
      />
    </div>
    <div style="margin-top: 20px"></div>
    <div style="margin-top: 50px">
      <MoneyTransactionHistoryTable :account="inAccount">
        <template v-slot:mtthead="">
          <div class="th">Date</div>
          <div class="th">Account</div>
          <div class="th">Currency</div>
          <div class="th">Value</div>
        </template>
        <template v-slot:mttbody="props">
          <div
            class="tr"
            v-if="props.item.src === 'admin' && props.item.crd != 'system'"
          >
            <div class="td">{{ getStringTime(props.item.m) }}</div>
            <div class="td">{{ props.item.crd }}</div>
            <div class="td">{{ props.item.cur }}</div>
            <div class="td">{{ props.item.val }}</div>
          </div>
        </template>
      </MoneyTransactionHistoryTable>
    </div>
    <!-- <div style="margin-top: 40px; margin-left: 0">
      <select v-model="selectedaccount" id="accountselector">
        <option disabled value="">{{ messages.topupS[store.langSelect.value] }}</option>
        <option
            v-for="(item, i) in accounts"
            :key="i"
            v-text="item.Account"
        ></option>
      </select>
      <div>
        <img :src="qrcodeImage" class="qrImage"/>
      </div>
      <div>
        <span>{{ bitAddr }}</span>
      </div>
      <div v-show="selectedaccount" style="margin-top: 50px">
        <Button :text=" messages.topupCreateAddrB[store.langSelect.value]" @click="getNewAddr"/>
      </div>
    </div>
   <div v-show="selectedaccount" style="margin-top: 50px">
      <div class="lk_content_title">{{ messages.topupHistoryH[store.langSelect.value] }}</div>
      <table id="bittransactions" cellspacing="0" style="margin-top: 30px">
        <thead>
        <tr>
          <th>{{ messages.topupHistoryD[store.langSelect.value] }}</th>
          <th>{{ messages.topupHistorySum[store.langSelect.value] }}</th>
          <th>ID</th>
          <th>{{ messages.topupHistoryC[store.langSelect.value] }}</th>
          <th>{{ messages.topupHistoryS[store.langSelect.value] }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(val, index) in transactions" :key="index">
          <td>{{ getTransDate(val.time) }}</td>
          <td>{{ val.amount }}</td>
          <td>{{ val.txid }}</td>
          <td>{{ getTransConfirmations(val.confirmations) }}</td>
          <td>{{ getTransStatus(val.confirmations) }}</td>
        </tr>
        </tbody>
      </table>
      <div v-show="selectedaccount" style="margin-top: 50px">
        <Button :text="messages.refreshB[store.langSelect.value]" @click="getTrans"/>
      </div>
    </div> -->
  </div>
</template>

<script>
import { reactive, ref, watch } from "vue";
import { useMyStorage, getAccPositions } from "@/store/global";
import { copyText } from "vue3-clipboard";
import MoneyTransactionHistoryTable from "./MoneyTransactionHistoryTable";

import SampleQrImage from "@/assets/sampleqr.png";
import SampleQrImageUSDT from "@/assets/sampleusdt.png";
import Button from "./Button";
import { DocumentCopy } from "@element-plus/icons-vue";
import { Warning } from "@element-plus/icons-vue";

export default {
  components: {
    MoneyTransactionHistoryTable,
    Button,
    DocumentCopy,
    Warning,
  },
  name: "DepositComponent",
  setup() {
    const inAccount = ref("");
    const inCurrency = ref("");
    const usdtType = ref("");
    const store = useMyStorage();
    const accountsAddress = reactive(store.accountsAddress);
    const accounts = store.userInfo.value.Info.Accounts;
    const inInstrument = ref("");
    const accUsdtAddresIs = ref(false);

    const qrcodeImage = ref(SampleQrImage);
    const qrcodeUstdImage = ref(SampleQrImageUSDT);
    //const bitAddr = ref("");
    //const usdtAddr = ref("It is not an address. TRC20 only");
    const refreshTimer = ref(0);
    const disabledRefreshButton = ref(false);
    //  const centri = store.centrifuge.value;
    store.CheckCrypto();
    const user = store.user.value;
    const CheckCrypto = () => {
      if (disabledRefreshButton.value == false) {
        refreshTimer.value = 10;
        disabledRefreshButton.value = true;
        store.CheckCrypto();
        if (store.cryptoServerIsActived.value == true) {
          getNewAddr();
        }
      }
    };
    const disabledRefreshButtonEvent = () => {
      refreshTimer.value = 0;
      disabledRefreshButton.value = false;
    };
    for (let i = 0; i < user.Accounts.length; i++) {
      //     console.log(user.Accounts[i].Account);
      if (accountsAddress[user.Accounts[i].Account] == undefined) {
        accountsAddress[user.Accounts[i].Account] = {
          qrBTC: SampleQrImage,
          addressBTC: "It is not an address.",
          qrUSDT: SampleQrImageUSDT,
          addressUSDT: "It is not an address. TRC20 only",
          accUsdtAddresIs: false,
          qrTonUSDT: SampleQrImageUSDT,
          addressTonUSDT: "It is not an address. TON only",
          accUsdtTonAddresIs: false,
        };
      }
      const dataSt = '{"inaccount":"' + user.Accounts[i].Account + '"}';
      const msg = { func: "GetInfo", data: dataSt };
      //   console.log(msg);
      if (!user.Accounts[i].Account.includes("_")) {
        store.GetAccountAddresses(msg);
      }
    }
    const getNewAddr = () => {
      const dataSt = '{"inaccount":"' + inAccount.value + '"}';
      const msg = { func: "GetNew", data: dataSt };
      store.GetAccountAddresses(msg);
    };
    accounts.forEach((v, i) => {
      if (!v.Account.includes("_")) {
        inAccount.value = accounts[i].Account;
        return;
      }
    });

    let positionsInAccount = getAccPositions(inAccount.value);
    const getStringTime = (val) => {
      // console.log(val)
      // console.log("++++++++++"+val+"----------")
      if (val < 2613553314) {
        let ts = new Date(val * 1000);
        return (
          ts.getUTCFullYear() +
          "-" +
          pad(ts.getUTCMonth() + 1) +
          "-" +
          pad(ts.getUTCDate()) +
          " " +
          pad(ts.getUTCHours()) +
          ":" +
          pad(ts.getUTCMinutes()) +
          ":" +
          pad(ts.getUTCSeconds())
        );
      }
      return "";
    };
    const doCopy = (t) => {
      let text = "";
      if (t === "bit") {
        text = accountsAddress[inAccount.value].addressBTC;
      } 
      if (t=="usdt") {
        text = accountsAddress[inAccount.value].addressUSDT;
      }
      if (t=="usdtton") {
        text = accountsAddress[inAccount.value].addressTonUSDT;
      }
      copyText(text, undefined, () => {});
    };
    const pad = (n) => {
      return n < 10 ? "0" + n : n;
    };
    const getInstrumentFromPosition = (acc, ticker) => {
      // console.log("getInstrumentFromPosition")
      //  console.log(acc)
      if (acc !== undefined) {
        let v = null;
        acc.value.forEach((el) => {
          if (el.Ticker === ticker) {
            v = el;
          }
        });
        // console.log(v)
        return v;
      }
      return null;
    };
    const currency = [
      { value: "BTC", name: "BTC" },
      {
        value: "USDT",
        name: "USDT",
      },
    ];
    inCurrency.value = currency[1].value;
    const usdt_type = [
      { value: "TRC20", name: "TRC20" },
    /*  {
        value: "TON",
        name: "TON",
      },*/
    ];
    usdtType.value = usdt_type[0].value;
    inInstrument.value = getInstrumentFromPosition(
      positionsInAccount,
      inCurrency.value
    );

    watch(
      () => positionsInAccount,
      () => {
        //   console.log("inPos")
        inInstrument.value = getInstrumentFromPosition(
          positionsInAccount,
          inCurrency.value
        );
        console.log(inInstrument.value);
      },
      { deep: true }
    );
    watch(
      () => inAccount.value,
      () => {
        positionsInAccount = getAccPositions(inAccount.value);
        inInstrument.value = getInstrumentFromPosition(
          positionsInAccount,
          inCurrency.value
        );
      }
    );
    watch(
      () => inCurrency.value,
      () => {
        // console.log("incur")
        inInstrument.value = getInstrumentFromPosition(
          positionsInAccount,
          inCurrency.value
        );
        // console.log(inInstrument)
      }
    );
    //   initCentrifugo();
    const cryptoServerIsNotActive = [
      "<b>Сервис временно не доступен</b>",
      "<b>Service is temporarily unavailable</b>",
    ];
    const messages = {
      account: ["Аккаунт", "Account"],
      exchange: ["Конвертация", "Exchange"],
      amount: ["Сумма", "Amount"],
      all: ["Все", "All"],
      thereis: ["Есть", "There is"],
      willbe: ["Будет ", "Will be"],
      exchange2: ["Обменять", "Exchange"],
      currency: ["Валюта", "Currency"],
      courseInfo: ["Индикативный курс обмена", "Indicative exchange rate"],
      sended: [
        "Заявка на обмен успешно отправлена. Обработка будет произведена в течении 30 минут.",
        "The exchange request has been successfully sent. Processing will be done within 30 minutes.",
      ],
      tableHead: ["История операций по", "History of transactions on account"],
      topupH: ["Пополнить счет", "Top up account"],
      topupS: ["Выберите счет", "Select account"],
      topupNot: [
        "Не доступно в Game контуре биржи",
        "Not available in the Game",
      ],
      topupHistoryH: ["История депозита", "Deposit history"],
      topupHistoryD: ["Дата", "Date"],
      topupHistorySum: ["Сумма", "Sum"],
      topupHistoryC: ["Сумма", "Confirm"],
      topupHistoryS: ["Статус", "Status"],
      topupCreateAddrB: ["Создать новый адрес", "Create new address"],
      topupCreateAddrUsdt: ["Создать адрес", "Create address"],
    };
    // bitAddr.value = "";
    /*   if (store.currentServer === 0) {
      bitAddr.value = messages.topupNot[store.langSelect.value];
    }*/
    return {
      inAccount,
      inInstrument,
      store,
      accounts,
      currency,
      getStringTime,
      positionsInAccount,
      messages,
      inCurrency,
      qrcodeImage,
      //   bitAddr,
      //   usdtAddr,
      getNewAddr,
      qrcodeUstdImage,
      accountsAddress,
      accUsdtAddresIs,
      doCopy,
      cryptoServerIsNotActive,
      refreshTimer,
      CheckCrypto,
      disabledRefreshButton,
      disabledRefreshButtonEvent,
      usdtType,
      usdt_type,
    };
  },
};
</script>
<style>
.el-input__inner {
  /* border-radius: 2px !important;
  border: 1px solid #c4c4c4 !important; */
  box-sizing: border-box !important;
  height: 36px !important;
  outline: none !important;
  padding: 0 15px 0 0 !important;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1) !important;
  /* width: 100% !important;*/
  cursor: pointer !important;
  display: block !important;
  font-family: Roboto !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-size: 17px !important;
  line-height: 20px !important;
  color: #222222 !important;
}

.el-input-number__decrease:hover:not(.is-disabled)
  ~ .el-input
  .el-input__inner:not(.is-disabled),
.el-input-number__increase:hover:not(.is-disabled)
  ~ .el-input
  .el-input__inner:not(.is-disabled),
.el-range-editor.is-active,
.el-range-editor.is-active:hover,
.el-select .el-input.is-focus .el-input__inner {
  border-color: #c4c4c4 !important;
}
.el-select .el-input.is-focus .el-input__wrapper {
  box-shadow: none !important;
}
.el-select .el-input__inner:focus {
  border-color: #c4c4c4 !important;
}

.el-select-dropdown__item.selected {
  color: #e82862 !important;
  font-weight: 700 !important;
}

.el-select-dropdown__item {
  font-family: Roboto !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-size: 17px !important;
  line-height: 20px !important;
  color: #222222 !important;
  padding: 5px 20px !important;
}

.el-select .el-input .el-select__caret {
  color: #222222 !important;
}
</style>
<style scoped>
div.currency {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: #777777;
  text-align: right;
  width: 284px;
}

span.all {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 17px;
  color: #222222;
  text-decoration: underline;
}

.myselector,
.myinput {
  display: inline-block;
  position: relative;
  height: 40px;
}

.my-input__suffix {
  position: absolute;
  height: 100%;
  top: 17px;
  text-align: center;
  color: #c0c4cc;
  transition: all 0.3s;
  pointer-events: none;
}

.myselector .my-input__inner {
  padding-right: 30px;
}

.my-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 2px;
  border: 1px solid #c4c4c4;
  box-sizing: border-box;
  height: 40px;
  outline: none;
  padding: 0 15px 0 15px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
  cursor: pointer;
  display: block;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  line-height: 20px;
  color: #222222;
}

.mylabel {
  text-align: left;
  color: #777777;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
}

div.rotate.close {
  background-color: white;
  border: none;
  color: white;
  display: inline-block;
  position: relative;
  margin: 0;
  padding: 0;
  width: 14px;
  height: 14px;
  cursor: pointer;
  transition: background 0s 0.3s;
  transform: rotate(45deg);
}

div.rotate {
  background-color: white;
  border: none;
  color: white;
  display: inline-block;
  position: relative;
  margin: 0;
  padding: 0;
  width: 14px;
  height: 14px;
  cursor: pointer;
  transition: background 0s 0.3s;
}

div.rotate:focus {
  outline: none;
  border: none;
  background-color: white;
}

div.rotate span {
  position: absolute;
  display: block;
  left: 0px;
  bottom: 6px;
  width: 100%;
  height: 2px;
  background-color: #000000;
  content: "";
}

div.rotate span::before {
  position: absolute;
  display: block;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #000000;
  content: "";
  transform: rotate(90deg);
}

.t_left {
  text-align: left !important;
}

.table {
  width: 100%;
  display: table;
  table-layout: fixed;
  /*min-height: 80px;*/
}

.cel,
.col {
  display: table-cell;
}

.vmiddle {
  vertical-align: middle;
}

.head {
  border-bottom: 1px solid #e82862;
  font-family: Proxima Nova Condensed;
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  line-height: 17px;
  color: #777777;
  width: 100%;
  padding-bottom: 4px;
  height: 17px;
}

.mytable {
  width: 100%;
  position: relative;
}

.head_info_rotate {
  position: absolute;
  left: -17px;
  top: 42px;
  padding: 0px;
  margin: 0px;
  -webkit-transform: rotate(-90deg);
  transform: rotate(-90deg);
  font-family: Proxima Nova Condensed;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
  color: #222222;
  width: 60px;
  text-align: right;
}

.head_closed {
  font-family: Proxima Nova Condensed;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
  color: #222222;
  border-bottom: 1px solid #e82862;
  padding-bottom: 1px;
}

.account_info_small_top {
  margin-left: 3px;
  font-family: Proxima Nova Condensed;
  font-size: 10px;
  font-style: normal;
  font-weight: normal;
  line-height: 12px;
  color: #777777;
  position: absolute;
  display: inline-block;
}

.mytable_row {
  height: 20px;
}

.col .mytable_row:nth-child(even) {
  background-color: #f7f7f7;
}
</style>
